import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const kolomData = [
  'NoNota', 'KodeReferensi', 'TanggalNota', 'IdAngkutan', 'NoKendaraan', 'Supplier',
  'JenisVarietes', 'KadarAci', 'Gross', 'Tare', 'Netto', 'Refraksi', 'BeratBersih',
  'harga', 'PBongkarSPM', 'TotalHargaSPM', 'PBongkarSTN', 'TotalHargaSTN',
  'KomisiGrossPerKG', 'KomisiGross', 'PremiPerKG', 'Premi', 'LpPerKG', 'LoyaltyPts',
  'KomisiBersih', 'StatusTransaksi',
];

const columnLabels = {
  NoNota: 'No Nota',
  KodeReferensi: 'Kode Referensi',
  TanggalNota: 'Tanggal Nota',
  IdAngkutan: 'ID Angkutan',
  NoKendaraan: 'No Kendaraan',
  Supplier: 'Supplier',
  JenisVarietes: 'Jenis Varietas',
  KadarAci: 'Kadar Aci',
  Gross: 'Gross',
  Tare: 'Tare',
  Netto: 'Netto',
  Refraksi: 'Refraksi',
  BeratBersih: 'Berat Bersih',
  harga: 'Harga',
  PBongkarSPM: 'P. Bongkar SPM',
  TotalHargaSPM: 'Total Harga SPM',
  PBongkarSTN: 'P. Bongkar STN',
  TotalHargaSTN: 'Total Harga STN',
  KomisiGrossPerKG: 'Komisi Gross/KG',
  KomisiGross: 'Komisi Gross',
  PremiPerKG: 'Premi/KG',
  Premi: 'Premi',
  LpPerKG: 'LP/KG',
  LoyaltyPts: 'Loyalty Pts',
  KomisiBersih: 'Komisi Bersih',
  StatusTransaksi: 'Status Transaksi',
};

const InvoiceFilter = ({ data = [], onClose }) => {
  const navigate = useNavigate();

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [supplier, setSupplier] = useState('');
  const [selectedColumns, setSelectedColumns] = useState([]);

  const handleCheckboxChange = (column) => {
    setSelectedColumns((prev) =>
      prev.includes(column) ? prev.filter((c) => c !== column) : [...prev, column]
    );
  };

  const handlePrint = () => {
    if (selectedColumns.length === 0) {
      alert('Pilih minimal satu kolom untuk dicetak.');
      return;
    }

    const filteredData = data.filter((item) => {
      if (fromDate && new Date(item.TanggalNota) < new Date(fromDate)) return false;
      if (toDate && new Date(item.TanggalNota) > new Date(toDate)) return false;
      if (supplier && !item.Supplier?.toLowerCase().includes(supplier.toLowerCase())) return false;
      return true;
    });

    const printableData = filteredData.map((item) => {
      const obj = {};
      selectedColumns.forEach((col) => {
        obj[col] = item[col];
      });
      return obj;
    });

    navigate('/preview-invoice', {
      state: {
        filteredData: printableData,
        selectedColumns,
        columnLabels, // ✅ Kirim label ke preview
      },
    });
  };

  return (
   <div
  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
  onClick={onClose}
>
  <div
    className="bg-white rounded-xl shadow-lg p-4 sm:p-5 w-full max-w-3xl max-h-[90vh] overflow-y-auto"
    onClick={(e) => e.stopPropagation()}
  >
    <h3 className="mb-4 text-base font-semibold text-gray-800 sm:text-lg">Filter Invoice</h3>

    {/* Filter Fields */}
    <div className="grid grid-cols-1 gap-3 mb-4 sm:grid-cols-2 md:grid-cols-3">
      <div>
        <label className="block mb-1 text-xs font-medium text-gray-700">Dari Tanggal Nota</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="w-full border border-gray-300 rounded px-2 py-[6px] text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
      <div>
        <label className="block mb-1 text-xs font-medium text-gray-700">Sampai Tanggal Nota</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="w-full border border-gray-300 rounded px-2 py-[6px] text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
      <div>
        <label className="block mb-1 text-xs font-medium text-gray-700">Supplier</label>
        <input
          type="text"
          placeholder="Cari supplier..."
          value={supplier}
          onChange={(e) => setSupplier(e.target.value)}
          className="w-full border border-gray-300 rounded px-2 py-[6px] text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
    </div>

    {/* Checkbox Section */}
    <div className="mb-4">
      <label className="block mb-1 text-xs font-medium text-gray-700">Kolom yang ingin dicetak</label>
      <div className="grid grid-cols-2 gap-2 p-2 overflow-y-auto text-xs border border-gray-200 rounded-md sm:grid-cols-3 md:grid-cols-4 max-h-48 bg-gray-50">
        {kolomData.map((col) => (
          <label key={col} className="flex items-center gap-1 text-gray-800">
            <input
              type="checkbox"
              checked={selectedColumns.includes(col)}
              onChange={() => handleCheckboxChange(col)}
              className="accent-green-600 w-3.5 h-3.5"
            />
            <span>{columnLabels[col] || col}</span>
          </label>
        ))}
      </div>
    </div>

    {/* Action Buttons */}
    <div className="flex justify-end gap-3 mt-5">
      <button
        onClick={handlePrint}
        className="bg-green-600 hover:bg-green-700 text-white text-xs px-3 py-1.5 rounded-md shadow-sm transition"
      >
        Preview
      </button>
      <button
        onClick={onClose}
        className="bg-gray-400 hover:bg-gray-500 text-white text-xs px-3 py-1.5 rounded-md shadow-sm transition"
      >
        Batal
      </button>
    </div>
  </div>
</div>

  );
};

export default InvoiceFilter;
